import React, { useEffect, useRef } from "react";

//design imports from material
import {
  Grid,
  FormLabel,
  TextField,
  Typography,
  Button,
  FormControl,
  Input,
} from "@mui/material";

//layout import
import Layout from "../../layout/Layout";

//form imports
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import StateList, { stateList } from "../../components/StateList";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
//date picker
import dayjs from "dayjs";

import axios from "axios";
import {
  config,
  gstNumberRegExp,
  ifscCodeRegExp,
  panCodeRegExp,
  pincodeRegExp,
  manageCompaniesAPI,
  statusMasterAPI,
  phoneRegExp,
  emailRegExp,
  urlRegExp,
} from "../../config";
import { AlertMessage } from "../../components/AlertMessage";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";

import { useNavigate } from "react-router-dom";

import { useState } from "react";

import coLogo from "../../assets/images/coLogo.jpg";
import NavigationGuard from "../../layout/NavigationGuard";

const ManageCoAdd = () => {
  const navigate = useNavigate();
  let tempRefs = useRef(false);

  // const [companyNames, setCompanyNames] = React.useState("");

  const validationSchema = Yup.object().shape({
    txtCompanyName: Yup.string().required("Company name is required"),
    txtAddress: Yup.string()
      .required("Address is required")
      .min(3, "Street Address must be at least 3 characters")
      .max(100, "Street Address cannot be more than 100 characters"),
    txtCity: Yup.string()
      .required("Town / City is required")
      .min(3, "Town / City must be at least 3 characters")
      .max(100, "Town / City cannot be more than 100 characters"),
    txtState: Yup.string()
      .required("State is required")
      .min(3, "State must be at least 3 characters")
      .max(100, "State cannot be more than 100 characters"),
    intPincode: Yup.string()
      .required("Pin Code is required")
      .min(6, "Pincode must be at least 6 digits")
      .max(6, "Pincode cannot be more than 6 digits")
      .matches(pincodeRegExp, "Please enter a valid Pincode"),

    txtPrimaryPhoneNumber: Yup.string()
      .required("Primary Phone Number is required")
      .matches(phoneRegExp, "Please enter a valid Phone number"),

    // txtSecondaryPhoneNumber: Yup.string()
    // .required("Secondary Phone Number is required"),

    txtEmailId: Yup.string().required("Email Id is required"),
    // .matches(emailRegExp, "Please enter a valid Email id"),

    txtWebsiteLink: Yup.string()
      .required("Website Link is required")
      .matches(urlRegExp, "Please enter a valid website URL"),

    // business validations
    txtPanNo: Yup.string().required("PAN Number is required"),
    // .matches(panCodeRegExp, "Please enter a valid PAN Number"),
    txtGstNo: Yup.string().required("GST Number is required"),
    // .matches(gstNumberRegExp, "Please enter a valid GST Number"),
    // txtTanNo: Yup.string().required("TAN Number is required"),

    // bank validation
    txtBankName: Yup.string().required("Bank Name is required"),
    txtBranch: Yup.string().required("Branch Name is required"),
    txtAccountName: Yup.string().required("Account Name is required"),
    txtAccountNo: Yup.string().required("Account Number is required"),
    txtIfscCode: Yup.string()
      .required("IFSC Code is required")
      .min(11, "IFSC Code must be 11 digits")
      .max(11, "IFSC Code must be 11 digits")
      .matches(ifscCodeRegExp, "Please enter a valid IFSC Code"),
  });

 
  
  const [stateName, setStateName] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");

  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  const [startDate, setStartDate] = React.useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = React.useState(dayjs().format("YYYY-MM-DD"));

  function onSubmit(data) {
    data.intType = 1;
    data.txtCoLogo = baseImage;
    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = manageCompaniesAPI;

  

    axios(config)
      .then(function (response) {
        handleFormReset();

        if (response.data.code == 501) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: "warning",
            })
          );
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: response.data.message,
              messageType: "success",
            })
          );

          setTimeout(function () {
            navigate("/manage-companies/list");
          }, 2000);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    handleFormReset();
  }, []);

  const handleFormReset = () => {
    let defaultValues = {};
    defaultValues.txtEndDate = endDate;
    reset({ ...defaultValues });
  };

  const childRef = useRef();

  

  const [baseImage, setBaseImage] = useState(coLogo);

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  return (
    <Layout>
      <Grid className="employee-form">
        <AlertMessage ref={childRef} />
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Manage Companies
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Company</Typography>
              <Typography color="text.primary">Manage</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="secondary"
              className="button_first"
              href="/manage-companies/list"
            >
              List Company
            </LoadingButton>
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        <form className="form_design" onSubmit={handleSubmit(onSubmit)}>
          {/* Company Name & Address */}
          <h3>Company Name & Address</h3>
          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              {/* <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Company Name
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={companyName}
                  label="Company Name"
                  onChange={(e) => {
                    setCompanyName(e.target.value);
                    setValue("txtCompanyName", e.target.value);
                  }}
                >
                  {companyNames &&
                    companyNames.length > 0 &&
                    companyNames.map((row, index) => (
                      <MenuItem value={row.id} key={index}>
                        {row.name}
                      </MenuItem>
                    ))}
                </Select>
                <Typography className="invalid-feedback">
                  {errors.txtCompanyName?.message}
                </Typography>
              </FormControl> */}

              <TextField
                name="name"
                type="text"
                label="Company name"
                fullWidth
                {...register("txtCompanyName")}
                error={errors.txtCompanyName ? true : false}
                helperText={errors.txtCompanyName?.message}
              />
            </Grid>

            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="address"
                type="text"
                label="Street Address"
                fullWidth
                {...register("txtAddress")}
                error={errors.txtAddress ? true : false}
                helperText={errors.txtAddress?.message}
              />
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="city"
                type="text"
                label="Town / City"
                fullWidth
                {...register("txtCity")}
                error={errors.txtCity ? true : false}
                helperText={errors.txtCity?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">State</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={stateName}
                  label="State"
                  onChange={(e) => {
                    setStateName(e.target.value);
                    setValue("txtState", e.target.value);
                  }}
                >
                  {stateList.map((row) => (
                    <MenuItem value={row.state_name}>{row.state_name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="Pincode"
                type="number"
                label="Pincode"
                fullWidth
                {...register("intPincode")}
                error={errors.intPincode ? true : false}
                helperText={errors.intPincode?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="Primary phone number"
                type="text"
                label="Primary Contact Number"
                fullWidth
                {...register("txtPrimaryPhoneNumber")}
                error={errors.txtPrimaryPhoneNumber ? true : false}
                helperText={errors.txtPrimaryPhoneNumber?.message}
              />
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="Secondary phone number"
                type="text"
                label="Secondary Contact Number"
                fullWidth
                {...register("txtSecondaryPhoneNumber")}
                error={errors.txtSecondaryPhoneNumber ? true : false}
                helperText={errors.txtSecondaryPhoneNumber?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="Company email id"
                type="text"
                label="Company Email Id"
                fullWidth
                {...register("txtEmailId")}
                error={errors.txtEmailId ? true : false}
                helperText={errors.txtEmailId?.message}
              />
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="Website Link"
                type="text"
                label="Website Link"
                fullWidth
                {...register("txtWebsiteLink")}
                error={errors.txtWebsiteLink ? true : false}
                helperText={errors.txtWebsiteLink?.message}
              />
            </Grid>
          </Grid>

          {/* Business details */}
          <h3>Business Details</h3>
          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="gstNo"
                type="text"
                label="GST No."
                fullWidth
                {...register("txtGstNo")}
                error={errors.txtGstNo ? true : false}
                helperText={errors.txtGstNo?.message}
              />
            </Grid>

            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="panNo"
                type="text"
                label="PAN No."
                fullWidth
                {...register("txtPanNo")}
                error={errors.txtPanNo ? true : false}
                helperText={errors.txtPanNo?.message}
              />
            </Grid>
          </Grid>
          <div className="empty-space-20"></div>
          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="tanNo"
                type="text"
                label="TAN No."
                fullWidth
                {...register("txtTanNo")}
                error={errors.txtTanNo ? true : false}
                helperText={errors.txtTanNo?.message}
              />
            </Grid>
          </Grid>

          {/* Bank details */}
          <h3>Bank Details</h3>
          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="bank_name"
                type="text"
                label="Bank Name"
                fullWidth
                {...register("txtBankName")}
                error={errors.txtBankName ? true : false}
                helperText={errors.txtBankName?.message}
              />
            </Grid>

            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="branch"
                type="text"
                label="Branch"
                fullWidth
                {...register("txtBranch")}
                error={errors.txtBranch ? true : false}
                helperText={errors.txtBranch?.message}
              />
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="account_no"
                type="number"
                label="Account Number"
                fullWidth
                {...register("txtAccountNo")}
                error={errors.txtAccountNo ? true : false}
                helperText={errors.txtAccountNo?.message}
              />
            </Grid>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="account_name"
                type="text"
                label="Account Name"
                fullWidth
                {...register("txtAccountName")}
                error={errors.txtAccountName ? true : false}
                helperText={errors.txtAccountName?.message}
              />
            </Grid>
          </Grid>

          <div className="empty-space-20"></div>

          <Grid container spacing={2}>
            <Grid item className="form-lable" xs={12} lg={6} md={6}>
              <TextField
                name="ifsc_code"
                type="text"
                label="IFSC Code"
                fullWidth
                {...register("txtIfscCode")}
                error={errors.txtIfscCode ? true : false}
                helperText={errors.txtIfscCode?.message}
              />
            </Grid>
          </Grid>

          {/* Logo Part */}
          <h3>ADD LOGO</h3>
          <Grid item className="avatar-profile" alignItems="left">
            <Grid alignItems="center">
              <Grid className="profile_upload">
                <Button variant="contained" component="label">
                  Upload
                  <input
                    {...register("txtCoLogo")}
                    onChange={(e) => {
                      uploadImage(e);
                    }}
                    hidden
                    accept="image/*"
                    multiple
                    type="file"
                  />
                </Button>
              </Grid>
              <img className="company_avatar_img" src={baseImage} alt="" />
              <h5 color="black">Upload Company Logo</h5>
              <Typography className="note">
                Allowed *.jpeg, *.jpg, *.png
              </Typography>
            </Grid>
          </Grid>

          {/* Button */}
          <Grid container className="submit-button" alignItems="center">
            <Grid item xs={12} lg={12} md={12}>
              <LoadingButton
                size="large"
                variant="contained"
                color="primary"
                type="submit"
                disabled={formState.isSubmitting}
              >
                Submit
              </LoadingButton>
            </Grid>
          </Grid>
        </form>
      </Grid>
      <>
      <NavigationGuard/>
    </>
    </Layout>
  );
};

export default ManageCoAdd;
